import React, { useState, useEffect } from 'react'
import { InputGroup, Position, Tag } from '@blueprintjs/core'
import InputFloat from './InputFloat'
import Validate from './Validate'

const InputCost = (props) => <InputFloat {...props} leftElement={<Tag minimal>{props.currency}</Tag>} />

export default InputCost
